module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dropdown', {
    staticClass: "branch-label",
    class: {
      small: _vm.small
    },
    attrs: {
      "placement": "bottom-start"
    },
    on: {
      "command": _vm.goto
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$config.branch_name))]), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  }), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.$config.branches), function(branch) {
    return _c('el-dropdown-item', {
      key: branch.url,
      attrs: {
        "command": branch.url
      }
    }, [_vm._v(_vm._s(branch.name))])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ef34680","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/basic/BranchLabel.vue
// module id = 300
// module chunks = 0